import useAlert from '../../../components/Alert/hooks/useAlert'
import { inviteOrgUser } from '../repository/inviteOrgUser'
import { OrgUser } from '../types/OrgUser'

type Props = {
  onInviteError?: (errors: string[]) => void
  onInviteSuccess?: () => void
}

const validateInvite = (user: OrgUser) => {
  const errors = []

  if (!user.firstName) errors.push('First name is required')
  if (!user.lastName) errors.push('Last name is required')
  if (!user.email) errors.push('Email is required')

  return errors
}

const useInvite = ({ onInviteSuccess, onInviteError }: Props) => {
  const { alertSuccess, alertErrors } = useAlert()

  const invite = (user: OrgUser) => {
    const errors = validateInvite(user)

    if (errors.length > 0) {
      alertErrors(errors)
      onInviteError?.(errors)
    } else {
      inviteOrgUser(user)
        .then((data) => {
          if (data === 'Invitation sent!') {
            alertSuccess('User successfully invited!')
            onInviteSuccess?.()
          } else {
            alertErrors(['Something went wrong. Please try again.'])
            onInviteError?.(['Something went wrong. Please try again.'])
          }
        })
        .catch((error) => {
          alertErrors([error])
          onInviteError?.([error])
        })
    }
  }

  return {
    invite
  }
}

export default useInvite
